import React from 'react';
import {
  CONTENT_MENU_ITEMS,
  CONTRACT_MENU_ITEMS,
  TOOLS_MENU_ITEMS,
  INGEST_MENU_ITEMS,
  META_DATA_STRUCTURE_MENU_ITEMS,
  REVENUE_MENU_ITEMS,
  SYNC_MENU_ITEMS,
  VENDOR_MENU_ITEMS,
} from 'constants/menu';
import { accountStore } from 'store/accountStore';

const ALL_MENU_ITEMS = [
  ...(VENDOR_MENU_ITEMS ?? []),
  ...(CONTENT_MENU_ITEMS ?? []),
  ...(META_DATA_STRUCTURE_MENU_ITEMS ?? []),
  ...(CONTRACT_MENU_ITEMS ?? []),
  ...(REVENUE_MENU_ITEMS ?? []),
  ...(INGEST_MENU_ITEMS ?? []),
  ...(SYNC_MENU_ITEMS ?? []),
  ...(TOOLS_MENU_ITEMS ?? []),
];

const extractPath = (item: unknown): string | null => {
  if (!item || typeof item !== 'object') return null;
  const label = (item as { label?: unknown }).label;
  if (!label || typeof label !== 'object') return null;
  const to = (label as { props?: { to?: unknown } }).props?.to;
  if (typeof to !== 'string') return null;
  return to.split('?')[0];
};

/**
 * 현재 사용자가 접근 가능한 첫 번째 메뉴의 경로를 반환.
 * Vendor 메뉴를 우선 탐색 (vendor 사용자는 vendor 메뉴부터 봐야 함).
 * 일치하는 메뉴 항목이 없으면 /login으로.
 */
export const getDefaultRoute = (): string => {
  const menus = accountStore.getMenus();
  for (const key of menus) {
    const item = ALL_MENU_ITEMS.find(i => i?.key === key);
    const path = extractPath(item);
    if (path) return path;
  }
  return '/login';
};
